module.exports = __webpack_public_path__ + "img/Variety.e16093e3.png";